import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

const DARK = {
  bg: '#0f0f1a',
  bgSecondary: '#1a1a2e',
  bgTertiary: '#181825',
  bgCard: 'rgba(255,255,255,0.04)',
  border: 'rgba(255,255,255,0.06)',
  borderLight: 'rgba(255,255,255,0.1)',
  text: '#e2e8f0',
  textSecondary: '#94a3b8',
  textMuted: '#64748b',
  accent: '#6366f1',
  accentHover: '#8b5cf6',
  success: '#22c55e',
  inputBg: 'rgba(255,255,255,0.04)',
  headerBg: 'linear-gradient(180deg, rgba(99,102,241,0.08) 0%, transparent 100%)',
  shadow: '0 8px 32px rgba(0,0,0,0.4)',
};

const LIGHT = {
  bg: '#f8fafc',
  bgSecondary: '#ffffff',
  bgTertiary: '#f1f5f9',
  bgCard: '#ffffff',
  border: '#e2e8f0',
  borderLight: '#cbd5e1',
  text: '#1e293b',
  textSecondary: '#475569',
  textMuted: '#94a3b8',
  accent: '#6366f1',
  accentHover: '#4f46e5',
  success: '#16a34a',
  inputBg: '#ffffff',
  headerBg: 'linear-gradient(180deg, rgba(99,102,241,0.04) 0%, transparent 100%)',
  shadow: '0 4px 16px rgba(0,0,0,0.08)',
};

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    localStorage.setItem('theme', mode);
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);

  const toggle = () => setMode(m => m === 'dark' ? 'light' : 'dark');
  const setThemeMode = (next) => {
    if (next === 'dark' || next === 'light') setMode(next);
  };
  const theme = mode === 'dark' ? DARK : LIGHT;

  return (
    <ThemeContext.Provider value={{ mode, theme, toggle, setMode: setThemeMode }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
